/*
 * Pasek zakupu na karcie produktu (sections/pasek-zakupu.liquid).
 *
 * Kiedy widoczny: dopiero gdy główne przyciski zakupu zjadą z ekranu w GÓRĘ.
 * Chowa się, gdy do nich wrócimy i gdy wjedziemy w stopkę — pasek ma
 * przypominać o zakupie, a nie zasłaniać końca strony.
 *
 * Przyciski nie mają własnego formularza: klikają prawdziwe przyciski w sekcji
 * produktu, więc działa wybrany wariant, ilość i walidacja pól haftu.
 * Cena i zdjęcie odświeżają się przy zmianie wariantu (Dawn podmienia wtedy
 * kolumnę z informacjami — łapiemy to obserwatorem DOM).
 */
(function () {
  if (window.__pasekZakupu) return;
  window.__pasekZakupu = true;

  var pasek = null;

  function przyciskKoszyka() {
    return document.querySelector('.product__info-container .product-form__submit');
  }

  function przyciskKup() {
    return document.querySelector(
      '.product__info-container .shopify-payment-button__button, .product__info-container [data-shopify="payment-button"] button'
    );
  }

  function rzadPrzyciskow() {
    return document.querySelector('.product__info-container .product-form__buttons');
  }

  function stopka() {
    return document.querySelector('.footer, footer');
  }

  function odswiezTresc() {
    if (!pasek) return;

    var cena = document.querySelector('.product__info-container .price');
    var doCeny = pasek.querySelector('[data-pasek-cena]');
    if (cena && doCeny) {
      // z bloku ceny bierzemy sam tekst kwoty, bez etykiet dla czytników ekranu
      var kwota = cena.querySelector('.price-item--sale, .price-item--regular');
      if (kwota) doCeny.textContent = kwota.textContent.trim();
    }

    /*
     * Zdjęcie bierzemy z galerii, ale prosimy CDN Shopify o rozmiar pod pasek
     * (parametr `width`). Bez tego trafiał tu kadr w rozmiarze galerii albo
     * miniatury — w obu przypadkach obrazek wyglądał źle.
     */
    var glowne = document.querySelector('.product__media-list .product__media-item.is-active img, .product__media img');
    var zdjecie = pasek.querySelector('[data-pasek-zdjecie]');
    if (glowne && zdjecie) {
      var adres = glowne.getAttribute('src') || glowne.currentSrc || '';
      if (adres) {
        var pod = adres.replace(/([?&])width=\d+/, '$1width=1200');
        if (pod === adres) pod = adres + (adres.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
        zdjecie.removeAttribute('srcset');
        zdjecie.src = pod;
      }
    }

    var zrodlo = przyciskKoszyka();
    var kopia = pasek.querySelector('[data-pasek-koszyk]');
    if (zrodlo && kopia) {
      kopia.disabled = zrodlo.hasAttribute('disabled');
      var napis = zrodlo.querySelector('span');
      if (napis) kopia.textContent = napis.textContent.trim();
    }

    var kup = pasek.querySelector('[data-pasek-kup]');
    if (kup) kup.hidden = !przyciskKup();
  }

  function pokaz(czy) {
    if (!pasek) return;
    pasek.classList.toggle('jest-widoczny', czy);
  }

  function pilnujWidocznosci() {
    var rzad = rzadPrzyciskow();
    if (!rzad) return;

    var stan = { przyciski: true, stopka: false };

    function przelicz() {
      pokaz(!stan.przyciski && !stan.stopka);
    }

    var obsPrzyciski = new IntersectionObserver(
      function (wpisy) {
        // liczy się tylko zjechanie w GÓRĘ — nad przyciskami pasek ma nie wyskakiwać
        var w = wpisy[0];
        stan.przyciski = w.isIntersecting || w.boundingClientRect.top > 0;
        przelicz();
      },
      { threshold: 0 }
    );
    obsPrzyciski.observe(rzad);

    var dol = stopka();
    if (dol) {
      var obsStopka = new IntersectionObserver(
        function (wpisy) {
          stan.stopka = wpisy[0].isIntersecting;
          przelicz();
        },
        // Chowamy dokładnie wtedy, gdy pasek zacząłby zasłaniać stopkę:
        // root skracamy o jego wysokość z małym zapasem.
        { threshold: 0, rootMargin: '0px 0px -64px 0px' }
      );
      obsStopka.observe(dol);
    }
  }

  document.addEventListener('click', function (e) {
    if (!pasek) return;

    if (e.target.closest('[data-pasek-koszyk]')) {
      e.preventDefault();
      var koszyk = przyciskKoszyka();
      if (koszyk) koszyk.click();
      return;
    }

    if (e.target.closest('[data-pasek-kup]')) {
      e.preventDefault();
      var kup = przyciskKup();
      if (kup) kup.click();
    }
  });

  function start() {
    pasek = document.querySelector('[data-pasek-zakupu]');
    if (!pasek || !rzadPrzyciskow()) return;
    pasek.hidden = false;
    odswiezTresc();
    pilnujWidocznosci();

    var korzen = document.querySelector('.product__info-container');
    if (!korzen || !window.MutationObserver) return;
    var czeka = false;
    new MutationObserver(function () {
      if (czeka) return;
      czeka = true;
      setTimeout(function () {
        czeka = false;
        odswiezTresc();
      }, 120);
    }).observe(korzen, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
